import React from 'react';
import { connect } from 'react-redux';
import { useIntl } from 'react-intl';
import Dialog from '@/components/dialogs/Dialog';
import DictionaryReportsPanel from './DictionaryReportsPanel';
import { hideDictionaryReports } from '../actions';

const DictionaryReportsDialog = ({
  category,
  code,
  name,
  hide,
  reportType,
  theme,
}) => {
  const intl = useIntl();
  const handleClose = () => hide(category, code, reportType);

  return (
    <Dialog
      {...(reportType && {
        title: intl.formatMessage(
          { id: `dataset.data.dictionary.${reportType}.reports.for` },
          { name },
        ),
      })}
      className="smallwizard aridhia-dictionary-reports-dialog"
      onClose={handleClose}
      size="large"
      theme={theme}
    >
      <DictionaryReportsPanel category={category} code={code} reportType={reportType} />
    </Dialog>
  );
};

const mapStateToProps = ({
  datasetReports: {
    dictionaryReportsDialog: {
      category, code, name, reportType,
    },
  },
}) => ({
  category,
  code,
  name,
  reportType,
});

const mapDispatchToProps = {
  hide: hideDictionaryReports,
};

export default connect(mapStateToProps, mapDispatchToProps)(DictionaryReportsDialog);
